var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useEffect, useReducer } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { toast } from "react-toastify";
import { getCustomFieldsRequest } from "../api/api";
import { SET_CUSTOM_FIELD_INITIAL_DATA, SET_CUSTOM_FIELD_LOADING, SET_CUSTOM_FIELDS, } from "../constants";
import { reducer } from "../reducers/custom-fields-reducer";
const initialState = {
    customFields: [],
    loading: true,
    entityId: "",
    entityType: null,
};
const CustomFieldsContext = createContext({
    state: initialState,
    customFieldsDispatch: () => { },
    fetchCustomFields: () => { },
});
const CustomFieldsContextProvider = ({ children, entityId, entityType, }) => {
    const [state, customFieldsDispatch] = useReducer(reducer, initialState);
    useEffect(() => {
        fetchCustomFields();
    }, []);
    useEffect(() => {
        customFieldsDispatch({
            type: SET_CUSTOM_FIELD_INITIAL_DATA,
            payload: { entityType, entityId },
        });
    }, [entityType, entityId]);
    const fetchCustomFields = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            customFieldsDispatch({ type: SET_CUSTOM_FIELD_LOADING, payload: true });
            const response = yield getCustomFieldsRequest(entityId, entityType);
            customFieldsDispatch({ type: SET_CUSTOM_FIELDS, payload: response.data });
        }
        catch (error) {
            console.error(error);
            toast.error(__("Failed to fetch custom fields", "quicktasker"));
        }
        finally {
            customFieldsDispatch({ type: SET_CUSTOM_FIELD_LOADING, payload: false });
        }
    });
    return (_jsx(CustomFieldsContext.Provider, { value: { state, customFieldsDispatch, fetchCustomFields }, children: children }));
};
export { CustomFieldsContext, CustomFieldsContextProvider, };
